import { DeleteOutlined, EditOutlined, SaveOutlined, SearchOutlined } from '@ant-design/icons';
import { Button, Card, Checkbox, Col, Form, Input, Modal, Popconfirm, Row, Skeleton, Space, Tooltip } from 'antd';
import React, { useEffect, useState } from 'react'
import { useStoreActions, useStoreState } from '../../../../store/hooks/easyPeasy';
import Table from "../../../../contents/AntTableResponsive";
import { SelectAcademicYear } from '../../../select/SelectAcademicYear';
import { SelectClassConfig } from '../../../select/SelectClassConfig';



export default function ListFeeDiscard(props) {

    const [form] = Form.useForm();
    const [updateForm] = Form.useForm();

    const feeheadDeletedList = useStoreState((state) => state.saccount.feeheadDeletedList);
    const fetchfeeheadDeletedList = useStoreActions((state) => state.saccount.fetchfeeheadDeletedList);
    const deletestudentFeeHeadLedgerConfiguration = useStoreActions((state) => state.saccount.deletestudentFeeHeadLedgerConfiguration);
    const updateStudentWaiver = useStoreActions((state) => state.saccount.updateStudentWaiver);
    const loading = useStoreState((state) =>  state.saccount.loading);


    const [sub, setsub] = useState<any>()
    const formSubmit = (value) => {
        setsub(value)
        fetchfeeheadDeletedList(value)
    }


    const updateFomrSubmit = (value) => {

        updateStudentWaiver(value);
        setIsModalVisible(false);
    }

    const [assignId, setassignId] = useState<any>();

    const columns = [

        {
            title: 'Student Id',
            dataIndex: 'customStudentId',
            key: 'customStudentId',
            showOnResponse: true,
            showOnDesktop: true,
        },
        {
            title: 'Student Name',
            dataIndex: 'studentName',
            key: 'studentName',
            showOnResponse: true,
            showOnDesktop: true,
        },
        {
            title: 'Student Roll',
            dataIndex: 'studentRoll',
            key: 'studentRoll',
            showOnResponse: true,
            showOnDesktop: true,
        },

        {
            title: 'Class',
            dataIndex: 'className',
            key: 'className',
            showOnResponse: true,
            showOnDesktop: true,
        },
        {
            title: 'Group',
            dataIndex: 'group',
            key: 'group',
            showOnResponse: true,
            showOnDesktop: true,
        },

        {
            title: 'Fee Head',
            dataIndex: 'feeHead',
            key: 'feeHead',
            showOnResponse: true,
            showOnDesktop: true,
        },


        {
            title: 'Action',
            key: 'studentId',
            showOnResponse: true,
            showOnDesktop: true,
            render: (text: any, record: any, index) => (
                <Space size="middle">

                    <Popconfirm
                        title="Are you sure to delete this?"
                        okText="Yes"
                        cancelText="No"
                        onConfirm={() => {
                            deletestudentFeeHeadLedgerConfiguration({ id: record?.id });
                            setTimeout(() => {
                                fetchfeeheadDeletedList(sub)
                            }, 500);
                        }}
                    >
                        <Tooltip title="Delete">
                            <Button danger icon={<DeleteOutlined />} />
                        </Tooltip>
                    </Popconfirm>
                </Space>
            ),
        },
    ];

    const [isModalVisible, setIsModalVisible] = useState(false);

    return (
        <>

            <Form
                layout="vertical"
                onFinish={formSubmit}
                id="basic-info"
                form={form}
            >
                <Row gutter={8}>
                    <Col xs={24} sm={24} md={24} lg={6} xl={6}> </Col>
                    <Col xs={24} sm={24} md={24} lg={6} xl={6}>
                        <Form.Item
                            name="academicYear"
                            label="Academic Year"
                            className="title-Text"
                            rules={[
                                { required: true, message: "Please select year " },
                            ]}
                        >
                            <SelectAcademicYear />

                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={6} xl={6}>
                        <Form.Item
                            name="classConfigId"
                            label="Section"
                            className="title-Text"
                            rules={[
                                { required: true, message: "Please select section" },
                            ]}
                        >
                            <SelectClassConfig />

                        </Form.Item>
                    </Col>

                    <Col xs={24} sm={24} md={24} lg={2} xl={2}>
                        <Space size="small" >
                            <Button type="primary" htmlType="submit" style={{ height: 40 }} icon={<SearchOutlined />}>
                                Search
                            </Button>
                        </Space>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={4} xl={4}> </Col>
                </Row>
            </Form>

            {feeheadDeletedList ===null && < Skeleton loading={loading} paragraph={{rows:10}} />}
            {feeheadDeletedList?.length > 0 &&
                <div className="datatable-responsive">
                    {/* <Table bordered={true} ledgerList={ledgerList} columns={columns} className="p-datatable-responsive-demo" /> */}

                    <Table
                        antTableProps={{
                            showHeader: true,
                            columns,
                            dataSource: feeheadDeletedList,
                            filterData: feeheadDeletedList,
                            pagination: false,
                            bordered: true,
                            rowKey: "assignId"
                        }}
                        mobileBreakPoint={768}
                    />
                </div>
            }


            <Modal
                title="Fee Head Discard"
                visible={isModalVisible}
                //  onOk={handleOk}
                okButtonProps={{ form: 'update', htmlType: 'submit' }}
                onCancel={() => setIsModalVisible(false)}
                cancelText="Close"
                okText="Save"
                centered
            >
                <Form
                    layout="vertical"

                    onFinish={updateFomrSubmit}
                    id="update"
                    form={updateForm}
                >


                    <Form.Item
                        name="waiverId"
                        label="Fee Waiver:"
                        className="title-Text"
                        rules={[
                            { required: true, message: "Please select fee waiver" },
                        ]}
                    >

                    </Form.Item>

                    <Form.Item
                        name="amount"
                        label="Amount:"
                        className="title-Text"
                    // rules={[
                    //     { required: true, message: "Please insert fee amount" },
                    // ]}
                    >
                        <Input placeholder="Amount" />
                    </Form.Item>



                </Form>

            </Modal>
        </>
    )
}
